import compact from 'lodash/compact'

type Options = {
  decimalPlace?: number
}

export const formatWithComma = (n?: number | null, options?: Options) => {
  if (n === null || n === undefined) {
    return ''
  }
  const { decimalPlace = 0 } = options || {}
  const [base, decimalDigits] = n.toFixed(decimalPlace).split('.')
  const formatted = base.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

  return compact([formatted, decimalDigits]).join('.')
}

export const inThousand = (n: number) => {
  const numberInThousand = Math.round(n / 1000)
  return formatWithComma(numberInThousand)
}

export const millionToThousand = (i: number | null) => {
  return i ? i * 1000 : null
}

export const thousandToMillion = (n: number | null) => {
  return n ? Number(n * 0.001) : null
}

type FormattedAmount = {
  value: string
  unit: string
}

type FormatAmountOptions = {
  estimated: boolean | undefined
}

export const formatAmount = (
  n: number | null,
  options: FormatAmountOptions = { estimated: false }
): FormattedAmount | null => {
  if (n === null || n === 0) {
    return null
  }
  if (options.estimated) {
    if (n / 1000 >= 1) {
      return {
        value: `${formatWithComma(thousandToMillion(n))}`,
        unit: '百万円（推定）',
      }
    }
    return { value: `${formatWithComma(n)}`, unit: '千円（推定）' }
  } else {
    if (n / 1000 >= 1) {
      return {
        value: `${formatWithComma(thousandToMillion(n))}`,
        unit: '百万円',
      }
    }
    return { value: `${formatWithComma(n)}`, unit: '千円' }
  }
}

export type UnitNumber = {
  value: number
  unit: null | 'K' | 'M' | 'B' | 'T'
}

export const toUnitNumber = (
  num: number,
  precision: number = 1
): UnitNumber => {
  if (num >= 1_000_000_000_000)
    return {
      value: divideAndRound(num, 1_000_000_000_000, precision),
      unit: 'T',
    }
  if (num >= 1_000_000_000)
    return { value: divideAndRound(num, 1_000_000_000, precision), unit: 'B' }
  if (num >= 1_000_000)
    return { value: divideAndRound(num, 1_000_000, precision), unit: 'M' }
  if (num >= 1_000)
    return { value: divideAndRound(num, 1_000, precision), unit: 'K' }
  return { value: num, unit: null }
}

const divideAndRound = (
  value: number,
  divisionNum: number,
  precision: number
): number => {
  const n = 10 ** precision
  return Math.floor((value * n) / divisionNum) / n
}
